import { Link } from "wouter";
import { Mail } from "lucide-react";
import { Logo } from "../ui/Logo";

const LINKS = [
  { href: "/events", label: "Browse Events" },
  { href: "/venues", label: "Venues" },
  { href: "/submit", label: "Submit an Event" },
  { href: "/about", label: "About" },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-card/40 mt-12">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
          {/* Brand */}
          <div className="max-w-xs">
            <Link href="/" className="inline-block text-foreground hover:opacity-75 transition-opacity">
              <Logo className="h-9 w-auto" />
            </Link>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              A directory of social dance events across New England — Swing, Ballroom,
              Salsa, Bachata, and more.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-col gap-2" aria-label="Footer">
            {LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Contact */}
          <div>
            <p className="text-sm font-semibold text-foreground mb-2">Contact</p>
            <a
              href="mailto:Info@nedances.com"
              className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <Mail className="w-4 h-4" />
              Info@nedances.com
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <p className="text-xs text-muted-foreground">
            © 2026 NE Dances. Created by Nate Munic for the New England social dance community.
          </p>
          <p className="text-xs text-muted-foreground">
            All times Eastern (ET) · Currently in beta.
          </p>
        </div>
      </div>
    </footer>
  );
}
